import moment from 'moment'

import cn from './zh-cn'
import us from './en-us'
import tw from './zh-tw'

import { computed, observable } from 'mobx'

const reg = /(\$\d)/g

function translate(lang, path: String, ...params) {
  try {
    let res: String = eval(`lang.${path}`)
    if (!res) throw new Error('no translation found for ' + path)
    if (res) {
      let i = 0
      return res.replace(reg, (all, match) => (match = [params[i++]]))
    }
  } catch (e) {
    console.error(e)
  }
  return path
}

class LangStore {
  @observable _curLang = 'cn'
  cn = cn
  us = us
  tw = tw

  set curLang(lang) {
    this._curLang = lang
  }

  @computed get curLang() {
    return this[this._curLang]
  }

  lang = (path, ...args) => {
    if (path) {
      return translate(this.curLang, path, ...args)
    }
    return this.curLang
  }
}

const langStore = new LangStore()

if (!window.lang) {
  window.lang = langStore
}

export default langStore



// WEBPACK FOOTER //
// ./src/i18n/index.js